// // src/components/Service.js
// import React from "react";

// const services = [
//   {
//     id: 1,
//     name: "35 Seater Bus On Rent In Pune",
//     desc: "Comfortable 35 seater bus rental service for corporate events, school trips, weddings, and group tours.",
//     image: "/images/services/35-Seater-Bus-on-Rent-in-Pune.jpg",
//     link: "/35-seater-bus-on-rent-in-pune",
//   },
//   {
//     id: 2,
//     name: "45 Seater Bus On Rent In Pune",
//     desc: "Affordable 45 seater bus hire service for large groups, corporate outings, and family tours.",
//     image: "/images/services/45-Seater-Bus-On-Rent-in-Pune.jpg",
//     link: "/45-seater-bus-on-rent-in-pune",
//   },
//   {
//     id: 3,
//     name: "AC Bus On Rent In Pune",
//     desc: "Premium AC bus rental service for comfortable travel across Pune and outstation destinations.",
//     image: "/images/services/AC-Bus-On-Rent-in-Pune.jpg",
//     link: "/ac-bus-on-rent-in-pune",
//   },
//   {
//     id: 4,
//     name: "Mini Bus On Rent In Pune",
//     desc: "Mini bus rental for family trips, corporate transportation, school outings, and local travel.",
//     image: "/images/services/Mini-Bus-On-Rent-in-Pune.jpg",
//     link: "/mini-bus-on-rent-in-pune",
//   },
//   {
//     id: 5,
//     name: "Pune To Goa Tempo Traveller Hire",
//     desc: "Book Tempo Traveller from Pune to Goa for family vacations, group tours, and weekend trips.",
//     image: "/images/services/Pune-to-Goa-Tempo-Traveller-Hire.jpg",
//     link: "/pune-to-goa-tempo-traveller-hire",
//   },
//   {
//     id: 6,
//     name: "Pune To Mahabaleshwar Bus",
//     desc: "Comfortable bus rental service for Mahabaleshwar tours, family vacations, and group travel.",
//     image: "/images/services/Pune-to-Mahabaleshwar-Bus.jpg",
//     link: "/pune-to-mahabaleshwar-bus",
//   },
//   {
//     id: 7,
//     name: "Pune To Outstation Bus",
//     desc: "Reliable outstation bus rental service from Pune for tours, events, and corporate travel.",
//     image: "/images/services/Pune-to-Outstation-Bus.jpg",
//     link: "/pune-to-outstation-bus",
//   },
//   {
//     id: 8,
//     name: "Tempo Traveller On Rent In Pune",
//     desc: "Luxury Tempo Traveller rental service in Pune for family trips, weddings, and corporate tours.",
//     image: "/images/services/Tempo-Traveller-On-Rent-in-Pune.jpg",
//     link: "/tempo-traveller-on-rent-in-pune",
//   },
//   {
//   id: 9,
//   name: "Pune to Shirdi Bus",
//   desc: "Comfortable Pune to Shirdi bus service for family trips, group tours, pilgrimage travel, and corporate journeys.",
//   image: "/images/services/Pune-to-Shirdi-Bus.jpg",
//   link: "/Pune-to-Shirdi-Mini-Bus",
// },
// ];

// const Service = () => {
//   return (
//     <>
//       {/* Page Header */}
//       <div className="page-headder bg-section parallaxie">
//         <div className="container">
//           <div className="row">
//             <div className="col-lg-12">

//               <div className="page-header-box text-white">

//                 <h1
//                   className="text-anime-style-3 text-center text-white"
//                   data-cursor="-opaque"
//                 >
//                   Our Services
//                 </h1>

//               </div>

//             </div>
//           </div>
//         </div>
//       </div>

//       {/* Services Section */}
//       <div className="section-full py-5 site-bg-white twm-cars-section-wrap">

//         <div className="container">

//           <div className="section-content">

//             <div className="twm-cars-section m-b30">

//               <div className="row">

//                 {services.map((service) => (

//                   <div
//                     key={service.id}
//                     className="col-lg-4 col-md-6 m-b30 wow fadeInDown"
//                     data-wow-delay="0.2s"
//                   >

//                     <div className="twm-vehicle-fleet-bx twm-custom-grid-3">

//                       {/* Image */}
//                       <div className="twm-media">

//                         <div className="twm-media-pi borderrr text-center">

//                           <img
//                             src={service.image}
//                             alt={service.name}
//                             className="img-fluid"
//                           />

//                         </div>

//                       </div>

//                       {/* Content */}
//                       <div className="twm-vehicle-fleet-content">

//                         <h3 className="twm-v-title text-center">

//                           <a
//                             // href={service.link}
//                             className="twmtitle darkcolo"
//                           >
//                             {service.name}
//                           </a>

//                         </h3>

//                         <ul className="twm-vehicle-facility">

//                           <li>{service.desc}</li>

//                         </ul>

//                       </div>

//                     </div>

//                   </div>

//                 ))}

//               </div>

//             </div>

//           </div>

//         </div>

//       </div>
//     </>
//   );
// };

// export default Service;










// src/components/Service.js

import React from "react";

const services = [
{
  id: 1,
  name: "Festival & Event Special Rides",
  desc: "Reliable bus rental service for festivals, weddings, and special events with comfortable seating and timely service.",
  image: "/images/services/Festival-&-Event-Special-Rides.jpg",
  link: "/35-seater-bus-on-rent-in-pune",
},

{
  id: 2,
  name: "Tempo Traveller Outstation Service",
  desc: "Comfortable Tempo Traveller service for long-distance outstation trips, family tours, and group travel with professional drivers.",
  image: "/images/keyword/3.jpg",
  link: "/35-seater-bus-on-rent-in-pune",
},

{
  id: 3,
  name: "Corporate Events Service",
  desc: "Dedicated corporate travel solutions for office outings, employee transportation, meetings, and business events with punctual service.",
  image: "/images/keyword/85.jpg",
  link: "/35-seater-bus-on-rent-in-pune",
},
{
id: 1,
name: "35 Seater Bus On Rent In Pune",
desc: "Comfortable 35 seater bus rental service for corporate events, school trips, weddings, and group tours.",
image: "/images/services/35-Seater-Bus-on-Rent-in-Pune.jpg",
link: "/35-seater-bus-on-rent-in-pune",
},
{
id: 2,
name: "45 Seater Bus On Rent In Pune",
desc: "Affordable 45 seater bus hire service for large groups, corporate outings, and family tours.",
image: "/images/services/45-Seater-Bus-On-Rent-in-Pune.jpg",
link: "/45-seater-bus-on-rent-in-pune",
},
{
id: 3,
name: "AC Bus On Rent In Pune",
desc: "Premium AC bus rental service for comfortable travel across Pune and outstation destinations.",
image: "/images/services/AC-Bus-On-Rent-in-Pune.jpg",
link: "/ac-bus-on-rent-in-pune",
},
{
id: 4,
name: "Mini Bus On Rent In Pune",
desc: "Mini bus rental for family trips, corporate transportation, school outings, and local travel.",
image: "/images/services/Mini-Bus-On-Rent-in-Pune.jpg",
link: "/mini-bus-on-rent-in-pune",
},
{
id: 5,
name: "Pune To Goa Tempo Traveller Hire",
desc: "Book Tempo Traveller from Pune to Goa for family vacations, group tours, and weekend trips.",
image: "/images/services/Pune-to-Goa-Tempo-Traveller-Hire.jpg",
link: "/pune-to-goa-tempo-traveller-hire",
},
{
id: 6,
name: "Pune To Mahabaleshwar Bus",
desc: "Comfortable bus rental service for Mahabaleshwar tours, family vacations, and group travel.",
image: "/images/services/Pune-to-Mahabaleshwar-Bus.jpg",
link: "/pune-to-mahabaleshwar-bus",
},
{
id: 7,
name: "Pune To Outstation Bus",
desc: "Reliable outstation bus rental service from Pune for tours, events, and corporate travel.",
image: "/images/services/Pune-to-Outstation-Bus.jpg",
link: "/pune-to-outstation-bus",
},
{
id: 8,
name: "Tempo Traveller On Rent In Pune",
desc: "Luxury Tempo Traveller rental service in Pune for family trips, weddings, and corporate tours.",
image: "/images/services/Tempo-Traveller-On-Rent-in-Pune.jpg",
link: "/tempo-traveller-on-rent-in-pune",
},
{
id: 9,
name: "Pune To Shirdi Bus",
desc: "Comfortable Pune to Shirdi bus service for family trips, group tours, pilgrimage travel, and corporate journeys.",
image: "/images/services/Pune-to-Shirdi-Bus.jpg",
link: "/Pune-to-Shirdi-Mini-Bus",
},
];

const Service = () => {
return (
<>
{/* Page Header */} <div className="page-headder service-header"> <div className="container"> <div className="row"> <div className="col-lg-12"> <div className="page-header-box text-center"> <span className="service-subtitle">
Premium Travel Solutions </span>

            <h1
              className="text-anime-style-3 text-white"
              data-cursor="-opaque"
            >
              Our Services
            </h1>

            <p className="text-white mt-3">
              Professional Bus, Tempo Traveller, Urbania & Group Travel
              Services Across Pune & Maharashtra.
            </p>
          </div>
        </div>
      </div>
    </div>
  </div>

  {/* Services Section */}
  <div className="section-full py-5 site-bg-white twm-cars-section-wrap">
    <div className="container">

      <div className="text-center mb-5">
        <h6 className="golden-heading">
          WHAT WE OFFER
        </h6>

        <h2 className="fw-bold">
          Reliable Travel & Transportation Services
        </h2>

        <p className="text-muted">
          Luxury Tempo Travellers, Urbania, Mini Buses & Coaches for every journey.
        </p>
      </div>

      <div className="row">

        {services.map((service) => (

          <div
            key={service.id}
            className="col-lg-4 col-md-6 mb-4 wow fadeInUp"
          >
            <div className="service-card-gold">

              {/* Image */}
              <div className="service-image-wrap">
                <img
                  src={service.image}
                  alt={service.name}
                  className="img-fluid"
                />

                <div className="service-overlay">
                  <span>Premium Service</span>
                </div>
              </div>

              {/* Content */}
              <div className="service-card-content">

                <h3 className="service-title text-center">
                  {service.name}
                </h3>

                <p className="service-desc text-center">
                  {service.desc}
                </p>

              

              </div>

            </div>
          </div>

        ))}

      </div>

    </div>
  </div>
</>


);
};

export default Service;
